import { Box, Heading, Text } from "@chakra-ui/react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useLoggedInWithOrgContextState } from "../../../common/auth/useLoggedInWithOrgContextState";
import { momentLocaleFor } from "../../../common/formatting/i18nFormatters";
import { timeGreetingKey } from "./greeting";

interface Props { headlineKey: string; }

export const GreetingHeader = ({ headlineKey }: Props) => {
  const { t, i18n } = useTranslation();
  const authState = useLoggedInWithOrgContextState();
  const firstName = authState.me?.firstName;
  const greeting = t(timeGreetingKey(new Date().getHours()));
  const dateText = moment().locale(momentLocaleFor(i18n.language)).format("dddd D. MMMM");

  return (
    <Box mb="6">
      <Text fontSize="sm" color="smMuted" mb="1">
        {greeting}{firstName ? `, ${firstName}` : ""} · {dateText}
      </Text>
      <Heading as="h1" size="lg" color="smText">{t(headlineKey)}</Heading>
    </Box>
  );
};
